"use strict";

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noTrailingUnmapper = exports.noTrailingMapper = exports.singleTrailingUnmapper = exports.singleTrailingMapper = exports.multiTrailingUnmapperOne = exports.multiTrailingMapperOne = exports.multiTrailingUnmapper = exports.multiTrailingMapper = exports.onlyTrailingUnmapper = exports.onlyTrailingMapper = exports.fullySpecifiedUnmapper = exports.fullySpecifiedMapper = void 0;

function readBh(value) {
  if (value.length === 0) return [];else return value.split(':');
}

function extractEhAndL(value) {
  var valueSplits = value.split(':');

  if (valueSplits.length >= 2 && valueSplits[valueSplits.length - 1].length <= 4) {
    return [valueSplits.slice(0, valueSplits.length - 2), "".concat(valueSplits[valueSplits.length - 2], ":").concat(valueSplits[valueSplits.length - 1])];
  }

  return [valueSplits.slice(0, valueSplits.length - 1), valueSplits[valueSplits.length - 1]];
}

function fullySpecifiedMapper(data) {
  return "".concat(data[0].join(':'), ":").concat(data[1]);
}

exports.fullySpecifiedMapper = fullySpecifiedMapper;

function fullySpecifiedUnmapper(value) {
  if (typeof value !== 'string') throw new Error('Invalid type');
  return extractEhAndL(value);
}

exports.fullySpecifiedUnmapper = fullySpecifiedUnmapper;

function onlyTrailingMapper(data) {
  return "::".concat(data[0].join(':'), ":").concat(data[1]);
}

exports.onlyTrailingMapper = onlyTrailingMapper;

function onlyTrailingUnmapper(value) {
  if (typeof value !== 'string') throw new Error('Invalid type');
  if (!value.startsWith('::')) throw new Error('Invalid value');
  return extractEhAndL(value.substring(2));
}

exports.onlyTrailingUnmapper = onlyTrailingUnmapper;

function multiTrailingMapper(data) {
  return "".concat(data[0].join(':'), "::").concat(data[1].join(':'), ":").concat(data[2]);
}

exports.multiTrailingMapper = multiTrailingMapper;

function multiTrailingUnmapper(value) {
  if (typeof value !== 'string') throw new Error('Invalid type');

  var _value$split = value.split('::', 2),
      _value$split2 = _slicedToArray(_value$split, 2),
      bhString = _value$split2[0],
      trailingString = _value$split2[1];

  var _extractEhAndL = extractEhAndL(trailingString),
      _extractEhAndL2 = _slicedToArray(_extractEhAndL, 2),
      eh = _extractEhAndL2[0],
      l = _extractEhAndL2[1];

  return [readBh(bhString), eh, l];
}

exports.multiTrailingUnmapper = multiTrailingUnmapper;

function multiTrailingMapperOne(data) {
  return multiTrailingMapper([data[0], [data[1]], data[2]]);
}

exports.multiTrailingMapperOne = multiTrailingMapperOne;

function multiTrailingUnmapperOne(value) {
  var out = multiTrailingUnmapper(value);
  return [out[0], out[1].join(':'), out[2]];
}

exports.multiTrailingUnmapperOne = multiTrailingUnmapperOne;

function singleTrailingMapper(data) {
  return "".concat(data[0].join(':'), "::").concat(data[1]);
}

exports.singleTrailingMapper = singleTrailingMapper;

function singleTrailingUnmapper(value) {
  if (typeof value !== 'string') throw new Error('Invalid type');

  var _value$split3 = value.split('::', 2),
      _value$split4 = _slicedToArray(_value$split3, 2),
      bhString = _value$split4[0],
      trailing = _value$split4[1];

  return [readBh(bhString), trailing];
}

exports.singleTrailingUnmapper = singleTrailingUnmapper;

function noTrailingMapper(data) {
  return "".concat(data[0].join(':'), "::");
}

exports.noTrailingMapper = noTrailingMapper;

function noTrailingUnmapper(value) {
  if (typeof value !== 'string') throw new Error('Invalid type');
  if (!value.endsWith('::')) throw new Error('Invalid value');
  return [readBh(value.substring(0, value.length - 2))];
}

exports.noTrailingUnmapper = noTrailingUnmapper;